export enum TransactionPaymentReportStatus {
  RJCT = 'RJCT',
  ACCP = 'ACCP',
  ACSC = 'ACSC',
  ACSP = 'ACSP',
  ACWC = 'ACWC',
}
